module.exports = __webpack_public_path__ + "static/media/halifaxWebBanner.9e2a1354.jpeg";